import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import * as actions from '../../../../services/actions';
import Bouton from '../../Bouton/Bouton';
import { checkMot } from '../../../../ressources/functionJS/checkMot';

const TableauGroupeEmail = ({ selectioneLigne }) => {
  const dispatch = useDispatch();

  // Redux state
  const list_emails_groups = useSelector(
    (state) => state.alarme.list_emails_groups
  );
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );

  // Local state
  const [columns] = useState([
    {
      dataField: 'group_email_id',
      text: checkMot('group_email_id'),
      sort: true,
    },
    {
      dataField: 'project_id',
      text: checkMot('project_id'),
      sort: true,
    },
    {
      dataField: 'email_group_name',
      text: checkMot('email_group_name'),
      sort: true,
    },
  ]);

  const [selectRow] = useState({
    mode: 'radio',
    clickToSelect: true,
    style: {
      background: '#a6153e',
      color: 'white',
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        selectioneLigne(row);
      }
    },
  });

  // Effect to fetch email groups on mount and when filter changes
  useEffect(() => {
    dispatch(actions.reqListeGroupesEmails(filtre_projects_list_id));
  }, [dispatch, filtre_projects_list_id]);

  const handleRefresh = () => {
    dispatch(actions.reqListeGroupesEmails(filtre_projects_list_id));
  };

  return list_emails_groups !== undefined && list_emails_groups.length > 0 ? (
    <BootstrapTable
      keyField={'group_email_id'}
      data={list_emails_groups}
      columns={columns}
      selectRow={selectRow}
    />
  ) : (
    <Bouton cliquer={handleRefresh}>{checkMot('refresh')}</Bouton>
  );
};

export default TableauGroupeEmail;
